module.exports = "/_next/static/images/corey-lydstone-720075687dece9e60019c791eddad1f5.jpg";